import 'antd/lib/slider/style/index';

import Slider, { SliderProps as AntSliderProps } from 'antd/lib/slider';

/**
 * Slider props
 */
export type SliderProps = AntSliderProps;

/**
 * An ant slider
 *
 * @deprecated TODO: https://transcend.height.app/T-19886 - remove ant
 */
export default Slider;
